import { AUTH_ACTIONS } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { useState, useEffect } from "react";
import { IAPIState } from "shared/types";

export const useIsUserPreferenceFormSubmitted = () => {
  const { status } = useStateActionMeta(AUTH_ACTIONS.editCurrentUser) || {};
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (status === IAPIState.succeeded) {
      setFormSubmitted(false);
    }
  }, [status]);

  return { isFormSubmitted, setFormSubmitted };
};
